/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
$(function() {
  $('.well').bind('closed', function() {
    return $.ajax({
      url: '/ajax/remove_info_text/' + $(this).data('id'),
      type: 'delete',
      dataType: 'script'
    });
  });

  $('.alert').bind('closed', function() {
    if ($(this).data('id')) {
      return $.ajax({
        url: '/ajax/remove_info_text/' + $(this).data('id'),
        type: 'delete',
        dataType: 'script'
      });
    }
  });

  return $( "input:submit, a.buttonStyleLink" ).button();
});

let eventsInfiniteScrollPending = false;
let eventsInfiniteScrollScheduled = false;
const eventsInfiniteScrollFrame = window.requestAnimationFrame || function(callback) {
  window.setTimeout(callback, 16);
};

function hasEventsInfiniteScroll() {
  return document.querySelector('[data-behavior="events-pagination"]');
}

function maybeLoadMoreEvents() {
  const button = document.querySelector('[data-behavior="events-load-more"]');

  if (!button) {
    return;
  }

  if (eventsInfiniteScrollPending || button.dataset.infiniteScrollDisabled === 'true') {
    return;
  }

  if (button.getBoundingClientRect().top <= window.innerHeight + 300) {
    eventsInfiniteScrollPending = true;
    button.click();
  }
}

function scheduleLoadMoreEvents() {
  if (!hasEventsInfiniteScroll() || eventsInfiniteScrollScheduled) {
    return;
  }

  eventsInfiniteScrollScheduled = true;

  eventsInfiniteScrollFrame(function() {
    eventsInfiniteScrollScheduled = false;
    maybeLoadMoreEvents();
  });
}

$(document).on('ajax:beforeSend', '[data-behavior="events-load-more"]', function() {
  const $button = $(this);

  eventsInfiniteScrollPending = true;

  $button
    .addClass('disabled')
    .attr('aria-busy', 'true')
    .attr('aria-disabled', 'true');

  $button.siblings('[data-behavior="events-load-more-spinner"]').removeClass('hide');
  $button.addClass('hide');
});

$(document).on('ajax:error', '[data-behavior="events-load-more"]', function() {
  const $button = $(this);

  eventsInfiniteScrollPending = false;

  $button
    .removeClass('disabled')
    .removeAttr('aria-busy')
    .removeAttr('aria-disabled');

  $button.attr('data-infinite-scroll-disabled', 'true');
  $button.removeClass('hide');
  $button.siblings('[data-behavior="events-load-more-spinner"]').addClass('hide');
});

$(document).on('events:content-loaded', function() {
  eventsInfiniteScrollPending = false;
  scheduleLoadMoreEvents();
});

document.addEventListener("DOMContentLoaded", function () {
  if (hasEventsInfiniteScroll()) {
    window.addEventListener('scroll', scheduleLoadMoreEvents, {passive: true});
    window.addEventListener('resize', scheduleLoadMoreEvents);
    scheduleLoadMoreEvents();
  }

  const expandableContainers = document.querySelectorAll('[data-expandable-container]');

  expandableContainers.forEach(function (container) {
    const content = container.querySelector('[data-expandable-content]');
    const toggle = container.querySelector('[data-expandable-toggle]');

    if (!content || !toggle) return;

    const showMoreText = toggle.dataset.showMore || toggle.textContent;
    const showLessText = toggle.dataset.showLess || toggle.textContent;

    const setExpanded = function (expanded) {
      container.classList.toggle('expanded', expanded);
      toggle.textContent = expanded ? showLessText : showMoreText;
      toggle.setAttribute('aria-expanded', expanded);
    };

    const updateToggleVisibility = function () {
      const wasExpanded = container.classList.contains('expanded');

      container.classList.remove('expanded');
      const lineHeight = parseFloat(window.getComputedStyle(content).lineHeight) || 16;
      const hasOverflow = (content.scrollHeight - content.clientHeight) > (lineHeight / 2);
      toggle.hidden = !hasOverflow;

      setExpanded(hasOverflow && wasExpanded);
    };

    setExpanded(false);
    window.requestAnimationFrame(updateToggleVisibility);

    toggle.addEventListener('click', function () {
      setExpanded(!container.classList.contains('expanded'));
    });

    window.addEventListener('resize', updateToggleVisibility);
    window.addEventListener('load', updateToggleVisibility);
    if (document.fonts) document.fonts.ready.then(updateToggleVisibility);
  });
});
